import { LOGGER_TYPES } from '../../LoggerFactory/loggerTypes';
import {
  wixDocsNavigationClick,
  wixDocsSiteVisit,
  wixDocsVisitLocalViewer,
} from '../../LoggerFactory/BiAnalyticsLogger/events';
import {
  getArticleNameFromPathname,
  getCategoryName,
  getCategoryNameFromPathname,
} from '../../LoggerFactory/BiAnalyticsLogger/events/utils';
import { sortNodesBySortOrderFirst } from '../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { getLocalViewerId, isLocalViewer } from '../../../utils/locationUtils';
import window from 'global';

export const logToGoogleAnalytics = (logger, location) => {
  logger
    .getLogger(LOGGER_TYPES.ANALYTICS_GOOGLE)
    .log(`virtual-wix-docs${location.pathname}${location.hash}`);
};

export const logNavigationClickFromLocation = (logger, location, store) => {
  logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsNavigationClick, {
    article_name: getArticleNameFromPathname(location.pathname, store),
    article_url: window && window.location && window.location.href,
    category_name: getCategoryNameFromPathname(location.pathname, store),
    nav_type: location.state.navType,
  });
};

export const logSiteVisit = (logger, location, store) => {
  logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsSiteVisit, {
    page_url: window && window.location && window.location.href,
    category_name: getCategoryName(location.pathname, store),
    article_name: getArticleNameFromPathname(location.pathname, store),
  });
  if (isLocalViewer(location)) {
    const localViewerId = getLocalViewerId(location);
    logger
      .getLogger(LOGGER_TYPES.ANALYTICS_BI)
      .log(wixDocsVisitLocalViewer, localViewerId);
  }
};

export const sendAppLoadedEvent = (logger) => {
  logger.getLogger(LOGGER_TYPES.FEDOPS).appLoaded();
};

export const getRelevantTree = (store) =>
  store.hasGuides() ? store.guidesTree : store.docsTree;

export const getFirstCategoryKey = (store) => {
  const tree = getRelevantTree(store);
  return sortNodesBySortOrderFirst(tree)[0];
};

export const getFirstCategoryNode = (store) => {
  const tree = getRelevantTree(store);
  const firstCategoryNodeKey = getFirstCategoryKey(store);
  return tree[firstCategoryNodeKey];
};

export const getFirstCategoryUrlFormat = (store) => {
  const firstCategoryNode = getFirstCategoryNode(store);
  return firstCategoryNode.data.urlFormat;
};
